import { render } from "./Factories.vue?vue&type=template&id=7fb4c84f&scoped=true"
import script from "./Factories.vue?vue&type=script&lang=js"
export * from "./Factories.vue?vue&type=script&lang=js"

import "./Factories.vue?vue&type=style&index=0&id=7fb4c84f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.25_vue@3.5.25_typescript@5.4.2__webpack@5.103.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fb4c84f"]])

export default __exports__